// Open Shopify's own consent controls only when the visitor requests them.
(() => {
  if (document.documentElement.dataset.ylCookiePreferencesBound) return;
  document.documentElement.dataset.ylCookiePreferencesBound = 'true';

  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-yl-cookie-preferences]');
    if (!button) return;

    const status = button.parentElement.querySelector('[data-yl-cookie-preferences-status]');
    if (status) {
      status.textContent = '';
      status.hidden = true;
    }

    try {
      const banner = window.privacyBanner;
      if (typeof banner?.showPreferences !== 'function') throw new Error('Privacy banner unavailable');
      await banner.showPreferences();
    } catch {
      if (status) {
        status.textContent = 'Cookie preferences are unavailable right now. Please try again later.';
        status.hidden = false;
      }
    }
  });
})();
